<template>
  <div class="user-info-small-card" :class="[`is-${gender}`]">
    <el-tooltip class="item" effect="dark" placement="bottom-start" :open-delay="500">
      <template slot="content">
        <a @click="handleGotoProfileClick" style="color: #fff">{{ $t('label.goto_profile') }}</a>
      </template>
      <div class="user-info-small-card__picture"
        :class="{ 'is-reactive': reactive }">
        <nuttrema-iconica-sidebar-link
           class="no-hover"
           size="picture"
           theme="professional"
          :noHover="true"
          :icon="icon"
          :picture="picture">
        </nuttrema-iconica-sidebar-link>
      </div>
    </el-tooltip>
    <div class="user-info-small-card__text">
      <div class="user-info-small-card__text__name">
        {{ _get(personDetails, 'full_name') }}
      </div>
      <div class="user-info-small-card__text__info" :class="{ 'is-reactive': reactive }">
        {{ _get(personDetails, 'email') }}
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';

import UserInfoSmallCard from './user-info-small-card';

export default {
  name: 'professional-info-small-card',
  mixins: [UserInfoSmallCard],
  methods: {
    handleGotoProfileClick() {
      this.$router.push({ name: 'team-member-details', params: { id: get(this.personDetails, 'id') } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/card/professional-info-small-card.vue